export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/plus-member.978db0a9.svg","height":15,"width":66};